var _style, _defs, _path, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMontasLogoNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_369",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 240.3 46.7",
    style: {
      enableBackground: "new 0 0 240.3 46.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000153707702747540215650000012190258590875797945_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#E30613;}\n\t.st2{clip-path:url(#SVGID_00000011714145014884375280000012000989272154885523_);}\n\t.st3{fill:url(#Rechteck_2_00000111150059899125984400000007475399328404347823_);}\n\t.st4{clip-path:url(#SVGID_00000110445463464895066280000018015883015199768967_);}\n\t.st5{fill:url(#Rechteck_3_00000118354816606236977200000001459843346692169373_);}\n\t.st6{clip-path:url(#SVGID_00000008150039316723679650000015371372882580597422_);}\n\t.st7{fill:url(#Rechteck_4_00000079483976820955104840000001331247213498538903_);}\n\t.st8{clip-path:url(#SVGID_00000000189347414386231680000006894095376774200194_);}\n\t.st9{fill:url(#Rechteck_5_00000094614012781880004860000001381474153112373149_);}\n\t.st10{clip-path:url(#SVGID_00000173143759708590749470000004549503311749185702_);}\n\t.st11{fill:url(#Rechteck_6_00000070085156736077651630000017313843361676173732_);}\n\t.st12{clip-path:url(#SVGID_00000127729975040963152130000004923680194836477834_);}\n\t.st13{fill:url(#Rechteck_7_00000134960232290137717120000005772629037699698567_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 240.3,
    height: 70.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182500442912415277040000014345199970307958434_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1",
    style: {
      clipPath: "url(#SVGID_00000182500442912415277040000014345199970307958434_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1",
    className: "st1",
    d: "M71.6,44.8l6.9-6.9l6.9,6.9c2.9-1.1,5.4-2.9,7.4-5.3l-6.4-6.4l-7.9-7.9l-7.9,7.9l-6.4,6.4 C66.2,41.9,68.7,43.7,71.6,44.8"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000101786967213337629330000013358003927942217624_",
    d: "M59.7,27.3c0,4.5,1.6,8.8,4.5,12.2l6.4-6.4 c-3.2-4.4-2.3-10.5,2-13.8c4.4-3.2,10.5-2.3,13.8,2c2.6,3.5,2.6,8.2,0,11.7l6.4,6.4c6.8-7.9,5.9-19.8-2-26.5 C82.8,6.2,71,7.2,64.2,15C61.3,18.5,59.7,22.8,59.7,27.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070115208196235307850000004875658527663068859_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101786967213337629330000013358003927942217624_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3",
    style: {
      clipPath: "url(#SVGID_00000070115208196235307850000004875658527663068859_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Rechteck_2_00000120536143025810141790000005181788863318129074_",
    cx: -491.1572,
    cy: -58.8851,
    r: 0.555,
    gradientTransform: "matrix(31.084 0 0 -31.066 15331.918 -1712.861)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#130C0E"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2",
    x: 59.7,
    y: 8.5,
    style: {
      fill: "url(#Rechteck_2_00000120536143025810141790000005181788863318129074_)"
    },
    width: 37.6,
    height: 31.1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000074439670110636388780000009158722331066749630_",
    d: "M30,14.8c-1.7-4-5.7-6.5-10-6.3c-4.1-0.1-8,2.1-10,5.8 l-0.2-3.8c0-0.9-0.4-1.2-1.1-1.2H1.2c-0.6,0-1,0.4-1.1,1v0.1v33.3c0,0.6,0.4,1.1,1,1.1h0.1H9c0.6,0,1.1-0.4,1.1-1v-0.1V25.2 c0-4.8,2.2-7.4,5.9-7.4c3.8,0,5.6,2.6,5.6,7.4v18.6c0,0.6,0.4,1.1,1,1.1c0.1,0,0.1,0,0.2,0h7.7c0.6,0,1-0.4,1.1-1v-0.1V25.2 c0-4.8,2.2-7.4,5.9-7.4c3.9,0,5.6,2.6,5.6,7.4v18.6c0,0.6,0.4,1,1,1.1h0.1H52c0.6,0,1-0.4,1.1-1v-0.1V23 c0-9.3-4.6-14.5-12.2-14.5C36.4,8.3,32.1,10.8,30,14.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105413126929758620450000009168765230505953162_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000074439670110636388780000009158722331066749630_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5",
    style: {
      clipPath: "url(#SVGID_00000105413126929758620450000009168765230505953162_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Rechteck_3_00000132078233980069505320000018391945485584957111_",
    cx: -493.5034,
    cy: -52.208,
    r: 0.626,
    gradientTransform: "matrix(36.2944 0 0 -36.29 17929.5918 -1780.8176)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#130C0E"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_3",
    x: 0.1,
    y: 8.5,
    style: {
      fill: "url(#Rechteck_3_00000132078233980069505320000018391945485584957111_)"
    },
    width: 53.1,
    height: 36.3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000094615828339297784010000010292624859675259527_",
    d: "M113.7,14.7l-0.3-4.2c0-0.9-0.4-1.2-1.1-1.2h-7.5 c-0.6,0-1,0.4-1.1,1v0.1v33.3c0,0.6,0.4,1,1,1.1h0.1h7.8c0.6,0,1-0.4,1.1-1v-0.1V25.4c0-5,2.7-7.7,6.9-7.7c4.3,0,6.6,2.7,6.6,7.7 v18.4c0,0.6,0.4,1.1,1,1.1h0.1h7.7c0.6,0,1.1-0.4,1.2-1v-0.1V23.1c0-9.3-5.4-14.6-12.8-14.6C119.9,8.4,115.7,10.8,113.7,14.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154393561266898890630000006374996337366223499_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094615828339297784010000010292624859675259527_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_7",
    style: {
      clipPath: "url(#SVGID_00000154393561266898890630000006374996337366223499_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Rechteck_4_00000029047460303281767930000017439469633148828809_",
    cx: -493.4988,
    cy: -52.208,
    r: 0.481,
    gradientTransform: "matrix(36.2826 0 0 -36.29 18035.9668 -1780.8176)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#130C0E"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_4",
    x: 103.7,
    y: 8.5,
    style: {
      fill: "url(#Rechteck_4_00000029047460303281767930000017439469633148828809_)"
    },
    width: 33.5,
    height: 36.3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000121989305983892973060000014037343251202495924_",
    d: "M148.7,0c-0.6,0-1,0.4-1.1,1v0.1v8.3h-4.5 c-0.6,0-1,0.4-1.1,1v0.1V16c0,0.6,0.4,1,1,1.1h0.1h4.5v17.8c0,7.7,5.1,10.3,10.7,10.3c2.4,0,6-0.4,6-2.1v-5.3 c0-0.7-0.5-1.1-1.3-1c-0.9,0.1-1.6,0.1-2.2,0.1c-1.5,0.2-2.9-0.9-3.1-2.5c0-0.2,0-0.4,0-0.6V17.1h5.6c0.6,0,1.1-0.4,1.1-1V16 v-5.6c0-0.6-0.4-1-1-1.1h-0.1h-5.6V1.1c0-0.6-0.4-1-1-1.1h-0.1H148.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176044268465150996040000009089521548452009647_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121989305983892973060000014037343251202495924_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_9",
    style: {
      clipPath: "url(#SVGID_00000176044268465150996040000009089521548452009647_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Rechteck_5_00000025415643947060269000000007893706047677411216_",
    cx: -496.2722,
    cy: -44.3425,
    r: 0.394,
    gradientTransform: "matrix(45.2445 0 0 -45.254 22764.9629 -1888.8325)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#130C0E"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_5",
    x: 142.1,
    style: {
      fill: "url(#Rechteck_5_00000025415643947060269000000007893706047677411216_)"
    },
    width: 22.3,
    height: 45.3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000071550336227879101410000002435161868713518976_",
    d: "M178.3,27.1c0-5.6,3.9-9.5,9.2-9.5s9,3.8,9,9.5 s-3.7,9.5-9,9.5S178.3,32.8,178.3,27.1 M168.5,27.1c0,10.6,6.9,18.6,16.8,18.6c4.6,0.2,9-2,11.6-5.9l0.1,3.9c0,0.6,0.4,1,1,1.1 h0.1h7c0.6,0,1.1-0.4,1.2-1v-0.1V10.5c0-0.6-0.4-1.1-1-1.1h-0.1h-7.1c-0.6,0-1,0.4-1.1,1v0.1l-0.1,3.9c-2.4-3.7-6.2-5.9-11.6-5.9 C175.4,8.5,168.5,16.6,168.5,27.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137100763975364530430000012902889104680937128_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071550336227879101410000002435161868713518976_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_11",
    style: {
      clipPath: "url(#SVGID_00000137100763975364530430000012902889104680937128_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Rechteck_6_00000111193763291715544600000005704927729809453753_",
    cx: -493.8314,
    cy: -51.2804,
    r: 0.504,
    gradientTransform: "matrix(37.1653 0 0 -37.158 18537.5742 -1792.0859)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#130C0E"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_6",
    x: 168.5,
    y: 8.5,
    style: {
      fill: "url(#Rechteck_6_00000111193763291715544600000005704927729809453753_)"
    },
    width: 37.8,
    height: 37.2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000090293449495874835940000008945024489205315995_",
    d: "M214.5,19.2c0,4.9,3.2,8,7.7,9.8l4.5,1.8 c2.6,1.1,3.7,1.9,3.7,3.6c0,2-1.6,3-4,3c-2.7,0-5.2-1.2-8.2-3.5c-0.4-0.4-1.1-0.5-1.6,0c-0.1,0.1-0.2,0.2-0.2,0.3l-2.5,3.5 c-0.5,0.6-0.6,1.4-0.1,2.1c3.3,3.8,8.2,6,13.2,5.9c7.1,0,13.2-3.7,13.3-10.8c0-0.1,0-0.1,0-0.1l0,0c0-5.3-3.5-8.4-8-10.2l-5-2 c-2-0.7-3.4-1.7-3.4-3.4c0-1.5,1.1-2.8,3.4-2.8c2.1,0,4.1,1,6.4,3c0.6,0.5,1.2,0.6,1.7,0l3.2-3.8c0.4-0.4,0.5-1.1,0.1-1.5 c-2.9-3.5-7.3-5.5-11.9-5.4C220.3,8.5,214.5,12.4,214.5,19.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072244485922024927370000008064672227445563801_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090293449495874835940000008945024489205315995_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_13",
    style: {
      clipPath: "url(#SVGID_00000072244485922024927370000008064672227445563801_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Rechteck_7_00000116945189768918334880000008208314889740947641_",
    cx: -493.826,
    cy: -51.2804,
    r: 0.436,
    gradientTransform: "matrix(37.1591 0 0 -37.158 18662.8066 -1792.0859)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    style: {
      stopColor: "#130C0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#130C0E"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_7",
    x: 213.3,
    y: 8.5,
    style: {
      fill: "url(#Rechteck_7_00000116945189768918334880000008208314889740947641_)"
    },
    width: 27,
    height: 37.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMontasLogoNoText);
export default __webpack_public_path__ + "static/media/montas_logo_no_text.48cbaec2a863effbf51d16939cd5aaba.svg";
export { ForwardRef as ReactComponent };